// import {
// 	XMarkIcon,
// } from '@heroicons/react/24/outline'

// import {
// 	Squares2X2Icon,
// } from '@heroicons/react/24/outline'

import { string } from 'yup';


const obj =  {
	field:[
		{ 
			title: "Topic or Keyword", 
			attr: "language",  
			value: "", 
			placeholder: "Fitness, Weight loss, Exercise", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
			id:"topicOrkeyword",
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Target audience", 
			attr: "content",  
			value: "", 
			id:"targetAudience",
			placeholder: "Health enthusiasts, Athletes, Fitness professionals", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Target audience is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Tone", 
			attr: "content",  
			value: "", 
			id:"tone",
			placeholder: "Professional, motivational, instructional", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Specific section", 
			attr: "content",  
			value: "", 
			id:"specificSection",
			placeholder: "Homepage, About us, Blog/Articles page", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Specific section is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
		{ 
			title: "Content length", 
			attr: "content",  
			value:250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("noOfTokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		}, 
	],
    example:[
		{ 
			title: "Topic or Keyword", 
			attr: "language",  
			value: "Weight loss", 
			placeholder: "Fitness, Weight loss, Exercise", 
			label: "Which language are you using, will enable markup highlights",
			type: "text",
			maxLength: 40,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required "),
			id:"topicOrkeyword",
			// options: [{ title: "2nd Grader", value: "2nd Grader", desc: "Explain this like I'm 5 years old", Icon: AnnotationIcon },],
			// max: 100,
			min: 3,
			required: true,
			error: "",
			example: `JavaScript`,
		},
		{ 
			title: "Target audience", 
			attr: "content",  
			value: "Health enthusiasts", 
			id:"targetAudience",
			placeholder: "Health enthusiasts, Athletes, Fitness professionals", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Target audience is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Tone", 
			attr: "content",  
			value: "Motivational", 
			id:"tone",
			placeholder: "Professional, motivational, instructional", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
        { 
			title: "Specific section", 
			attr: "content",  
			value: "Homepage, About us", 
			id:"specificSection",
			placeholder: "Homepage, About us, Blog/Articles page", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("Specific section is Required"),
			// max: 100,
			min: 3,
			required: true,
			error: "",
			type: "textarea",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
		{ 
			title: "Content length", 
			attr: "content",  
			value:250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("noOfTokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
	],

	editor:{
		output: `Welcome to Weight Loss For Health Enthusiasts! We are a community of passionate individuals who are dedicated to helping others achieve their health and fitness goals. Whether you’re looking to lose weight, gain muscle, or just become healthier overall, we have the tools and resources you need to succeed. 
At Weight Loss For Health Enthusiasts, we believe that health is a journey – not a destination. That means it’s all about progress over perfection! Our goal is to help you make small changes that will add up over time and lead you towards better health. We provide tips on nutrition, exercise routines, meal plans and more so that you can reach your goals in the most effective way possible. 
We also understand that losing weight can be difficult at times – which is why we strive to provide motivation along the way. Our team of experts will work with you every step of the way so that you never feel like giving up on your journey towards a healthier lifestyle. With our support and guidance, we know that anything is possible! 
So if you’re ready to take control of your life and make healthy changes for good, join us today at Weight Loss For Health En`,
		// Playing games on easy mode is a great way to relax and de-stress. Easy mode gaming can be an enjoyable way to unwind and take your mind off things.
	}
	}
	
	
	export default obj
	
	